import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  const menuButton = document.querySelector('.menu-icon');
  const menu = document.getElementById('main-menu');

  menuButton.addEventListener('click', () => {
    menuButton.classList.toggle('is-active');
    menu.classList.toggle('is-active');
  });

  mobileMenuHandler();

  /**
   * Mobile Burger menu
   */
  function mobileMenuHandler() {
    const $headerMenu = $('.header-menu');
    const $menuItems = $headerMenu.find('li.menu-item-has-children');
    const $burgerBtn = $('.menu-icon');

    $menuItems.each(function () {
      if (!$(this).children('.dropdown-toggle').length) {
        $(this).append('<div class="dropdown-toggle"></div>');
      }
    });

    $headerMenu.on('click touchstart', '.dropdown-toggle', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $parent = $(this).closest('li');
      const $submenu = $parent.children('.submenu');

      const $openSiblings = $parent.siblings('li.open');

      if ($openSiblings.length) {
        $openSiblings
          .removeClass('open')
          .children('.submenu')
          .stop(true, true)
          .slideUp(250);
      }

      $parent.toggleClass('open');
      $submenu.stop(true, true).slideToggle(250);
    });

    $burgerBtn.on('click', function () {
      $('body').toggleClass('menu-open');
    });
  }
});
